export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '机构名称',
    dataIndex: 'qichacha_name',
  },
  // {
  //   title: '社会统一信用代码',
  //   dataIndex: 'qichacha_credit_code',
  // },
  // {
  //   title: '法人代表',
  //   dataIndex: 'qichacha_oper_name',
  // },
  // {
  //   title: '营业状态',
  //   dataIndex: 'qichacha_status',
  // },
  {
    title: '合作时间',
    dataIndex: 'qichacha_start_date',
  },
  // {
  //   title: '操作',
  //   dataIndex: 'operation',
  //   scopedSlots: { customRender: 'operation' },
  // },
];

export const formData1 = [
  {
    name: 'website',
    lable: '企业网址',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'taxscale',
    lable: '纳税规模',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'contact',
    lable: '联系方式',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'nature',
    lable: '行业性质',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'provinceCity',
    lable: '所在省市',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'corporation',
    lable: '法人身份证',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'location',
    lable: '',
    lableCol: 5,
    wrapperCol: 17,
    offset: 5,
    span: 12,
  },
];
export const formData2 = [
  {
    name: 'bankname',
    lable: '开户行',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'banksubname',
    lable: '开户支行',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'banknum',
    lable: '银行账号',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'bankaccount',
    lable: '账号名称',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'invoicetitle',
    lable: '发票开头',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'taxidnum',
    lable: '纳税人识别号',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'invoicetype',
    lable: '发票类型',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
];
export const formData3 = [
  {
    name: 'consignee',
    lable: '收件人姓名',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'shipaddress',
    lable: '收件地址',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'consigneephone',
    lable: '手机号码',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'zipcode',
    lable: '邮政编码',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
];

export const formData4 = [
  {
    name: 'blImg',
    lable: '营业执照照片',
    lableCol: '',
    wrapperCol: '',
    offset: 0,
    span: 8,
  },
  {
    name: 'operimgfront',
    lable: '法人身份证-正面照',
    lableCol: '',
    wrapperCol: '',
    offset: 0,
    span: 8,
  },
  {
    name: 'operimgbackend',
    lable: '法人身份证-反面照',
    lableCol: '',
    wrapperCol: '',
    offset: 0,
    span: 8,
  },
  {
    name: 'bankopeningimg',
    lable: '开户许可证',
    lableCol: '',
    wrapperCol: '',
    offset: 0,
    span: 8,
  },
  {
    name: 'leaseimgs',
    lable: '办公场所租凭合同或产权证明',
    lableCol: '',
    wrapperCol: '',
    offset: 0,
    span: 8,
  },
  {
    name: 'otherimgs',
    lable: '其他证照',
    lableCol: '',
    wrapperCol: '',
    offset: 0,
    span: 8,
  },
];
